export default __webpack_public_path__ + "static/media/asnee-fernando.f5cf4c36.jpg";